import { takeEvery, put, call } from "redux-saga/effects"

import {
  GET_SUBSCRIPTION,
  INIT_SETUP_PAYMENT_METHOD,
  INIT_INSTANT_PAYMENT_METHOD,
} from "./actionTypes"

import {
  getSubscriptionOk,
  getSubscriptionErr,
  initSetupPaymentMethodOk,
  initSetupPaymentMethodErr,
  initInstantPaymentMethodOk,
  initInstantPaymentMethodErr,
} from "./actions"

import {
  getMySubscription,
  initSetupPaymentMethod,
  initInstantPaymentMethod,
} from "~/helpers/backendHelper";

/********** SUBSCRIPTION **********/

function* onGetSubscription() {
  try {
    const response = yield call(getMySubscription);
    yield put(getSubscriptionOk(response));
  } catch (error) {
    yield put(getSubscriptionErr(error));
  }
}

function* onInitSetupPaymentMethod() {
  try {
    const response = yield call(initSetupPaymentMethod);
    yield put(initSetupPaymentMethodOk(response));
  } catch (error) {
    yield put(initSetupPaymentMethodErr(error));
  }
}

function* onInitInstantPaymentMethod({ payload: { id, data } }) {
  try {
    const response = yield call(initInstantPaymentMethod, id, data);
    yield put(initInstantPaymentMethodOk(response));
  } catch (error) {
    yield put(initInstantPaymentMethodErr(error));
  }
}

function* authSaga() {
  yield takeEvery(GET_SUBSCRIPTION, onGetSubscription);
  yield takeEvery(INIT_SETUP_PAYMENT_METHOD, onInitSetupPaymentMethod);
  yield takeEvery(INIT_INSTANT_PAYMENT_METHOD, onInitInstantPaymentMethod);
}

export default authSaga;
